<template>
  <div class="column is-4 box">
    <div class="tabs">
      <ul>
        <li v-bind:class="{ 'is-active': activeTab === 'register'}">
          <a
            @click="activeTab = 'register'"
            v-bind:class="{'is-active': activeTab === 'register' }"
          >
            Register
          </a>
        </li>
        <li v-bind:class="{ 'is-active': activeTab === 'login'}">
          <a
            @click="activeTab = 'login'"
            v-bind:class="{'is-active': activeTab === 'login' }"
          >
            Sign In
          </a>
        </li>
      </ul>
    </div>

    <login
      v-if="activeTab === 'login'"
      v-on:change-active-tab="(tab) => { activeTab = tab }"
    />
    <register
      v-if="activeTab === 'register'"
    />
    <forgot-password
      v-if="activeTab === 'forgotPassword'"
      v-on:change-active-tab="(tab) => { activeTab = tab }"
    />
  </div>
</template>

<script>
import Login from '@/components/user/Login.vue';
import Register from '@/components/user/Register.vue';
import ForgotPassword from '@/components/user/ForgotPassword.vue';

export default {
  name: 'LoginRegister',
  components: {
    ForgotPassword,
    Register,
    Login,
  },
  data() {
    return {
      activeTab: 'register',
    };
  },
};
</script>

<style lang="scss" scoped>
  .tabs {
    a {
      color: #000 !important;

      &.is-active {
          color: hsl(204, 71%, 53%) !important;
       }
    }
  }
</style>
